<template>
  <div id="home"
       class="public-box">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'home'
}
</script>



// WEBPACK FOOTER //
// src/views/home/Index.vue